import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "competition-detail"
}
const _hoisted_2 = { class: "container pt-4" }
const _hoisted_3 = { class: "d-flex justify-content-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "img-fluid pb-4",
  src: "https://htmlstream.com/front-v4.0/assets/img/160x160/img1.jpg",
  style: {"max-height":"200px"}
}
const _hoisted_6 = { class: "mt-4 text-center" }
const _hoisted_7 = { class: "fs-5 text-center" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex rounded-2 justify-content-center bg-soft-primary mt-9 p-4"
}
const _hoisted_9 = {
  key: 0,
  class: "mx-6 text-center"
}
const _hoisted_10 = { class: "mt-4" }
const _hoisted_11 = {
  key: 1,
  class: "mx-6 text-center"
}
const _hoisted_12 = { class: "mt-4" }
const _hoisted_13 = {
  key: 2,
  class: "mx-6 text-center"
}
const _hoisted_14 = { class: "mt-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "border-divider" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResultMedal = _resolveComponent("ResultMedal")!
  const _component_TeamResult = _resolveComponent("TeamResult")!

  return (_ctx.isMounted && _ctx.currentCompetition != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.currentCompetition.photo != null)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "img-fluid pb-4",
                  src: _ctx.currentCompetition.photo.url,
                  style: {"max-height":"200px"}
                }, null, 8, _hoisted_4))
              : (_openBlock(), _createElementBlock("img", _hoisted_5))
          ]),
          _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.currentCompetition.name), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.currentCompetition.startedAt) + " - " + _toDisplayString(_ctx.currentCompetition.endedAt), 1),
          (
          _ctx.currentCompetition.haveMedals &&
          _ctx.currentCompetition.medals &&
          (_ctx.currentCompetition.medals[1] ||
            _ctx.currentCompetition.medals[2] ||
            _ctx.currentCompetition.medals[3])
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_ctx.currentCompetition.medals[1])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_ResultMedal, {
                        position: 1,
                        maxHeight: 120
                      }),
                      _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.currentCompetition.medals[1]), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.gold")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.currentCompetition.medals[2])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_ResultMedal, {
                        position: 2,
                        maxHeight: 120
                      }),
                      _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.currentCompetition.medals[2]), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.silver")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.currentCompetition.medals[3])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_ResultMedal, {
                        position: 3,
                        maxHeight: 120
                      }),
                      _createElementVNode("h2", _hoisted_14, _toDisplayString(_ctx.currentCompetition.medals[3]), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.bronze")), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _hoisted_15,
          _createVNode(_component_TeamResult, {
            haveMedals: _ctx.currentCompetition.haveMedals,
            entity: _ctx.competitionEntity
          }, null, 8, ["haveMedals", "entity"])
        ])
      ]))
    : _createCommentVNode("", true)
}